// extracted by mini-css-extract-plugin
module.exports = {"content":"how-to-apply_content__CYQHa","content-child":"how-to-apply_content-child___mDqS"};